import React, { useCallback, useEffect, useId, useState } from "react";
import "./InfoPopup.css";

/** Systemowy toast; dotychczasowe formularze zachowują obsługę trigger, warning i errorMode. */
export default function InfoPopup({
  title = "",
  errorDescription = null,
  trigger,
  warning = false,
  errorMode = false,
  actionOnAccept,
  allowForward = false,
  variant,
  stacked = false,
  onClose,
  children,
  role,
  onKeyDown,
}) {
  const [visible, setVisible] = useState(false);
  const [paused, setPaused] = useState(false);
  const messageId = useId();
  const tone =
    variant || (errorMode ? "danger" : warning ? "warning" : "success");
  const close = useCallback(() => {
    setVisible(false);
    onClose?.();
  }, [onClose]);
  useEffect(() => {
    if (trigger > 0) setVisible(true);
  }, [trigger]);
  useEffect(() => {
    if (!visible || paused || !["success", "info"].includes(tone)) return;
    const timer = setTimeout(close, 5000);
    return () => clearTimeout(timer);
  }, [trigger, visible, paused, tone, close]);
  if (!visible) return null;
  return (
    <div
      className={`alert alert-${tone} alert-dismissible d-flex flex-column ${stacked ? "" : "fixed-top w-25 ms-auto fade elementFromRight"}`}
      style={
        stacked
          ? undefined
          : {
              marginTop: errorMode ? "175px" : "125px",
              zIndex: 100,
              overflow: "auto",
              maxHeight: "80%",
            }
      }
      role={
        role || (tone === "danger" || tone === "warning" ? "alert" : "status")
      }
      aria-label={role === "alertdialog" ? "Potwierdzenie operacji" : undefined}
      aria-atomic="true"
      aria-describedby={role === "alertdialog" ? messageId : undefined}
      onKeyDown={onKeyDown}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget))
          setPaused(false);
      }}
    >
      {errorMode && errorDescription ? (
        <>
          <div className="d-flex flex-column custom-scrollbar">
            {errorDescription.Errors.map((error, index) => (
              <div key={index}>
                <strong>{error.Header}</strong>
                <ul>
                  {error.Description.map((description, i) => (
                    <li className="text-break" key={i}>
                      {description}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            {errorDescription.Disclaimer && (
              <div>{errorDescription.Disclaimer}</div>
            )}
          </div>
          {allowForward && (
            <div className="d-flex flex-column h6">
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-1"
                onClick={actionOnAccept}
              >
                Mimo wszystko chcę przejść dalej
              </button>
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-1"
                onClick={close}
              >
                Chcę poprawić błędy
              </button>
            </div>
          )}
        </>
      ) : (
        <div id={messageId} style={{ whiteSpace: "pre-line" }}>
          {title.trimEnd()}
        </div>
      )}
      {children}
      <button
        type="button"
        className="btn-close"
        onClick={close}
        aria-label="Zamknij komunikat"
      />
    </div>
  );
}
